<div class="card card-info d-flex flex-column mt-3 pb-4 mx-auto"
     style="width: 97%;border-radius: 12px"
     [ngStyle]="{'margin-bottom': last ? '110px' : '1em'}"
     #contentBorderSelectTop>


  <!-- HEADER -->
  <div class="room-header"
       style="position: relative; padding: 35px 3.25em"
  >
    <div class="room-info">
      <p class="room-label">Tipo de habitación</p>
       <p class="room-type pr-5">{{ roomSelect.room.roomType }}</p>
    </div>

  </div>

  <!-- DETALLE DEL CUARTO -->
   <usb-room-detail
                    [detailRoomData]="detailRoomData"
                    [clientSetting]="clientSetting"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    (openPolitics)="openPolitics()"
   ></usb-room-detail>


  <!-- OTRAS OPCIONES -->
<div class="room-options-container">
  <div class="room-options-wrapper">
    <div class="d-flex align-items-center" style="gap: 6px">
      <p class="room-options-title"  style="line-height: 1">Opciones de habitación</p>
       <p class="room-option-until" style="line-height: 1">(Disponibilidad: {{ getAllotment(groupedRoomOptions)  }}  {{ getAllotment(groupedRoomOptions) > 1 ? 'habitaciones' : 'habitación'}})</p>
    </div>


          <div class="room-options-list">
            <ng-container *ngFor="let r of groupedRoomOptions; let i = index; let last = last">
              <div class="d-flex flex-column room-option-row" style="padding-bottom: 25px; padding-top: 25px"
                          [style.border-bottom]="!last ? '2px solid #000000' : 'none'"
                >
                <div class="room-option-item">

                  <!-- Columna 1: Tipo de habitación -->
                  <div class="room-option-type">
                    <p class="room-option-name">{{ roomSelect.room.roomType }}</p>
                    <p class="room-option-board">{{ r?.boardName || 'Room Only' }}</p>
                  </div>
                  <!-- Columna 2: Política de cancelación -->
                  <div class="room-option-cancellation">
                    <p class="room-option-rate" [ngStyle]="{'color': r?.rateClass === 'R' ? '#00d096' : '#ed3b5b'}">
                      {{ r?.rateClass === "R" ? 'Reembolsable' : 'No Reembolsable' }}
                    </p>
              <p class="room-option-until">
                  Hasta {{getCancellationPolicyFrom(r.options[0]?.room) === 'N/A' ? 'N/A' : (getCancellationPolicyFrom(r.options[0]?.room) | date : 'dd/MM/yyyy')}}</p>
                  </div>

                  <!-- Columna 3: Precio -->
                  <div class="room-option-price">
                    <p class="room-option-amount">
                      {{ currencyAgency.code }} {{ r?.options[0]?.room?.netPriceProf
                            | currencyConverterPure: r?.options[0]?.room?.pricing?.currency: currencyAgency.code: currencies
                            | number: '1.2-2' }}
                    </p>
                    <p class="room-option-period">(Por Noche)</p>
                  </div>


                  <!-- Columna 4: Checkbox -->
                  <div class="room-option-checkbox">

                          <button
                                  type="button"
                                  class="btn btn-options"
                                  (click)="toggleDetail(i, r)"
                                  [ngStyle]="{'background-color':  buttonColorActive}"
                                  >
                                  {{ isDetailOpen ? 'Ocultar detalle' : 'Ver detalle' }}
                          </button>
                  </div>

                  <!-- Columna 5: Disparidad Tarifaria -->
                  <div class="room-option-competitor">
                    <button type="button" class="btn"
                            (click)="openCompetitorModal(r)"
                            style="background-color: transparent; color: #666666; font-family: 'Rubik', serif;
                                   font-size: 12px; font-weight: 500; text-decoration: underline;
                                   border: 1px solid #ececec; padding: 0.4em 1em; cursor: pointer; white-space: nowrap;">
                      Disparidad Tarifaria
                    </button>
                  </div>
                </div>

                <div class="d-flex flex-column">

                    <!-- <div *ngIf="validPaymentConditionAgencyAvailable(r?.rateClass)" class="mt-3 mb-2" style="width: 100%;font-weight: 500">
                         <p class="room-option-until" style="font-weight: 500">Asignar {{ selectedRoomsFilterVisible ? 'habitaciones' : 'habitación'}}</p>
                    </div> -->

                    <div class="d-flex alig-items-center" [ngStyle]="{'justify-content': !selectedRoomsFilterVisible ? 'flex-end' : ''}" style="gap: .5em">


                      <ng-container *ngIf="!validPaymentConditionAgencyAvailable(r?.rateClass)">

                          <div
                          class="d-flex justify-content-start align-items-center pl-3 mt-4  " style="background-color: #fae7eb; width: 100%; padding: .25em 0;border-radius: 8px; height: 40px" >
                          <p class="mb-0"  style="font-family: 'Poppins'; font-size: 14px;font-weight:500;color: #ed3b5b">
                            No es posible seleccionar un producto "no reembolsable" debido a las condiciones de pago de la agencia
                        </div>

                      </ng-container>


                      <ng-container *ngIf="validPaymentConditionAgencyAvailable(r?.rateClass)">



                        <ng-container *ngFor="let config of r.availableConfigs; let i = index">

                          <div *ngIf="config.isEmpty" class="d-flex flex-column w-100 mt-3" style="gap: 6px">

                            <div  class="d-flex flex-column p-2 justify-content-center"
                                style="width: 100%; height: 11px; border-radius: 8px;"></div>
                              <div
                                class="d-flex flex-column p-2 justify-content-center"
                                style="width: 100%; min-height: 70px; border-radius: 8px; border: 2px solid;"
                                [style.border-color]="'#dddddd'"
                                [style.background-color]="'white'">
                                <div style="height: 2px; width: 100%; background-color: #dddddd; transform: rotate(145deg);"></div>
                            </div>

                          </div>



                          <div *ngIf="!config.isEmpty" class="d-flex flex-column align-items-center w-100 mt-3" style="gap: 6px"
                               [ngStyle]="{'justify-content': config?.option?.room?.promotions?.promotionApplied && config?.option?.room?.promotions?.promotionApplied.length > 0 ? 'flex-end' : 'center'}"
                             >

                            <div class="position-relative d-flex flex-column align-items-center justify-content-end"
                                 style="width: 100%; min-height: 11px;"
                                 cdkOverlayOrigin
                                 #promotionOrigin="cdkOverlayOrigin">

                             <img
                                  *ngIf="config?.option?.room?.promotions?.promotionApplied && config?.option?.room?.promotions?.promotionApplied.length > 0"
                                  src="../../../../../assets/icons/search-result/hotel/02_estrella.svg"
                                  style="width: 11px;cursor: pointer"
                                  (mouseenter)="onMouseEnter($event, config)"
                                  (mouseleave)="onMouseLeave($event, config)"
                                  alt="">

                              <div
                                *ngIf="config?.option?.room?.promotions?.promotionApplied && config?.option?.room?.promotions?.promotionApplied.length === 0"
                                class="d-flex flex-column p-2 justify-content-center"
                                style="width: 100%; min-height: 11px; border-radius: 8px;"></div>

                              <ng-template
                                  cdkConnectedOverlay
                                  [cdkConnectedOverlayOrigin]="promotionOrigin"
                                  [cdkConnectedOverlayOpen]="!!config._promotionTooltipOpen"
                                  [cdkConnectedOverlayPositions]="promotionOverlayPositions"
                                  [cdkConnectedOverlayHasBackdrop]="false">

                                <div (mouseenter)="onMouseEnter($event, config)"
                                     (mouseleave)="onMouseLeave($event, config)">

                                  <div *ngIf="getPromotionConfigRoom(config?.option?.room?.promotions?.promotionApplied)?.currency"
                                       class="d-flex flex-column shadow-md"
                                       style="border:2px solid #ed3b5b;background-color:white; border-radius: 18px; padding: 7px 16px;">
                                    <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 500; line-height: 1;color: #ed3b5b; white-space: nowrap;">Ahorras</p>
                                    <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 600; line-height: 1;color: #ed3b5b; white-space: nowrap;">
                                      {{currencyAgency?.code}}
                                      {{getPromotionConfigRoom(config?.option?.room?.promotions?.promotionApplied)?.discount_value  | currencyConverterPure:
                                        getPromotionConfigRoom(config?.option?.room?.promotions?.promotionApplied)?.currency:
                                        currencyAgency?.code:
                                          currencies
                                        | number: '1.2-2'}}
                                      </p>
                                  </div>

                                  <div *ngIf="!getPromotionConfigRoom(config?.option?.room?.promotions?.promotionApplied)?.currency"
                                       class="d-flex justify-content-center align-items-center shadow-md"
                                       style="border:2px solid #ed3b5b;background-color:white; border-radius: 50rem; padding: 5px 16px; height: 26px">
                                    <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 14px;font-weight: 600;color: #ed3b5b; white-space: nowrap;">{{getPromotionConfigRoom(config?.option?.room?.promotions?.promotionApplied)?.discount_value}}% OFF</p>
                                  </div>

                                </div>
                              </ng-template>

                            </div>

                            <div
                                class="d-flex flex-column p-2 justify-content-center"
                                style="width: 100%; min-height: 70px; border-radius: 8px; border: 2px solid; cursor: pointer; transition: all 0.2s ease;"
                                [style.border-color]="isOccupancyRoomSelected(config.option?.room?.occupancyRoom, config) ? buttonColorActiveDark : '#000000'"
                                [style.background-color]="isOccupancyRoomSelected(config.option?.room?.occupancyRoom, config) ? clientSetting?.clients_setting_global?.color_main_1 + '10' : 'white'"
                                (click)="addConfigSelectedRoom(config, r)">

                                <div class="d-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <p class="mb-0" style="font-family: 'Poppins'; font-size: 12px; font-weight: 600; line-height: 1.2;"
                                    [style.color]="isOccupancyRoomSelected(config.option?.room?.occupancyRoom, config) ? buttonColorActiveDark : '#000000'">
                                      Habitación {{ config?.option?.room?.occupancyRoom }}
                                    </p>
                                  </div>
                                </div>

                                <!-- Adultos -->
                                <div class="d-flex align-items-center">
                                  <p class="mb-0" style="font-family: 'Poppins'; font-size: 12px; font-weight: 400; line-height: 1.2;"
                                  [style.color]="isOccupancyRoomSelected(config.option?.room?.occupancyRoom, config) ? buttonColorActiveDark : '#000000'">
                                    {{ config.isEmpty ? '-' : config.adults }} adultos
                                  </p>
                                </div>

                                <!-- Niños -->
                                <div class="d-flex align-items-center">
                                  <p class="mb-0" style="font-family: 'Poppins'; font-size: 12px; font-weight: 400; line-height: 1.2;"
                                  [style.color]="isOccupancyRoomSelected(config.option?.room?.occupancyRoom, config) ? buttonColorActiveDark : '#000000'">
                                    {{ config.isEmpty ? '-' : config.childrenCount }} niños
                                  </p>
                                </div>

                              </div>
                          </div>



                          </ng-container>

                      </ng-container>

                    </div>


                </div>





              <!-- 🔹 DESPLEGABLE CON DETALLES -->
                <div  *ngIf="isDetailOpen && i === indexOpened"
                  class="room-detail-container"
                  style="margin-top: 12px; ">

                <div class="d-flex flex-column" style="background: #f8f9fa; border-radius: 8px; padding: 30px 30px 20px 30px;margin-top: 15px;margin-bottom: 15px">
                      <div class="room-detail-header"
                      [ngStyle]="{'grid-template-columns': r.options[i]?.room?.pricing?.taxesExcluded > 0 ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'}"
                    style="display: grid; gap: 16px; padding-bottom: 12px;">
                  <div class="room-option-name">Condiciones</div>
                  <div class="room-option-name">Régimen</div>
                  <div class="room-option-name">Tarifa por noche</div>
                  <div *ngIf="r.options[i]?.room?.pricing?.taxesExcluded > 0" class="room-option-name d-flex">
                    <div>Cargos</div>
                       <usb-tooltip-taxes-breakdown
                                [taxes]="r.options[i]?.room?.pricing?.taxes"
                                [currency]="r.options[i]?.room?.pricing?.currency">
                              </usb-tooltip-taxes-breakdown>
                  </div>
                  <div class="room-option-name">Total estadía</div>
                </div>

                <!-- Filas de detalles -->
                <ng-container *ngFor="let option of r.options; let i = index">
                  <ng-container *ngIf="i === 0">
                    <div  class="room-detail-row"
                     [ngStyle]="{'grid-template-columns': r.options[i]?.room?.pricing?.taxesExcluded > 0 ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'}"
                    style="display: grid; gap: 16px; padding: 8px 0;margin-bottom: 20px">
                      <!-- Condiciones -->
                        <div class="info-content">
                            <ng-container *ngIf="option.room?.rateClass == 'NR'">
                              <p class="cancellation-nonrefundable" style="margin-left: 0">NO REEMBOLSABLE</p>
                              <p class="cancellation-fee" style="margin-left: 0">100% Tarifa</p>
                            </ng-container>
                            <ng-container *ngIf="option.room?.rateClass == 'R'">
                              <p class="cancellation-refundable" style="margin-left: 0">REEMBOLSABLE</p>
                              <p class="cancellation-policy-link" (click)="open(option, true, i)" style="margin-left: 0">Ver políticas</p>
                            </ng-container>
                          </div>

                        <!-- Régimen -->
                        <div>
                          <p class="info-text-move" style="margin-left: 0">
                            {{ r?.boardName || 'Room Only' }}
                          </p>
                        </div>

                        <!-- Tarifa por noche -->
                        <div>
                          <div class="price-value">
                            <p class="price-amount-move" style="margin-left: 0" *ngIf="option?.room?.netPriceProf">
                              {{ currencyAgency.code }}
                              {{ option?.room?.netPriceProf | currencyConverterPure: option?.room?.pricing?.currency : currencyAgency.code : currencies | number: '1.2-2' }}
                            </p>
                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientSetting"
                              [currencyProduct]="detailRoomData?.currencyProduct"
                              [valueProduct]="detailRoomData?.netPriceProf  + detailRoomData?.priceTaxExcluded">
                            </usb-tooltip-convert-amount>
                          </div>
                          <p class="price-taxes-move" style="margin-left: 0">Imp. incluidos</p>
                        </div>

                        <div *ngIf="option?.room?.pricing?.taxesExcluded">
                          <div class="price-value">

                              <p class="price-amount-move" style="margin-left: 0" *ngIf="option?.room?.netPriceProf">
                                {{ currencyAgency.code }}
                                {{ option?.room?.pricing?.taxesExcluded | currencyConverterPure: option?.room?.pricing?.currency : currencyAgency.code : currencies | number: '1.2-2' }}
                              </p>



                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientSetting"
                              [currencyProduct]="detailRoomData?.currencyProduct"
                              [valueProduct]="option?.room?.pricing?.taxesExcluded">
                            </usb-tooltip-convert-amount>

                          </div>
                          <p class="price-taxes-move" style="margin-left: 0">Pagar en destino</p>
                        </div>

                        <!-- Total estadía -->
                        <div>
                          <div class="price-value">
                            <p class="price-amount-move" style="margin-left: 0" *ngIf="option?.room?.optionNightsNetTotalProf">
                              {{ currencyAgency?.code }}
                              {{ (option?.room?.optionNightsNetTotalProf + option.room?.pricing?.taxesExcluded)| currencyConverterPure: option?.room?.pricing?.currency : currencyAgency.code : currencies | number: '1.2-2' }}
                            </p>
                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientSetting"
                              [currencyProduct]="detailRoomData?.currencyProduct"
                              [valueProduct]="detailRoomData?.optionNightsNetTotalProf + detailRoomData?.priceTaxExcluded">
                            </usb-tooltip-convert-amount>
                          </div>
                          <p class="price-taxes-move" style="margin-left: 0">Imp. incluidos</p>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  </div>
                <!-- Cabecera de columnas -->


                   <!-- Políticas de Cancelación -->
                  <usb-cancellation-policies
                              class="accordion-item-policies"
                              #politicsSection
                              [cancellationPolicies]="cancellationDetailData"
                              [currencies]="currencies"
                              [currencyAgency]="currencyAgency"
                              [categoryId]="1">
                  </usb-cancellation-policies>

                    <!-- <usb-accordion-info-product
                      #accordionDetailComponent
                      [items]="accordionItemsDetailData"
                      [config]="accordionConfigDetailData"
                      [infoRoom]="true"
                      [categoryId]="1"
                      (itemToggle)="onAccordionDetailToggle($event)">

                      <ng-template #accordionContent let-item let-index="index">
                        <ng-container [ngSwitch]="item.id">

                          <div *ngSwitchCase="'policies'">
                            <usb-cancellation-policies
                              class="accordion-item-policies"
                              #politicsSection
                              [cancellationPolicies]="cancellationDetailData"
                              [currencies]="currencies"
                              [currencyAgency]="currencyAgency"
                              [categoryId]="1">
                            </usb-cancellation-policies>
                          </div>

                        </ng-container>
                      </ng-template>

                    </usb-accordion-info-product> -->
                </div>


              </div>

            </ng-container>
          </div>



  </div>
</div>

  <!-- EXTRAS -->
  <div *ngIf="roomSelect?.room?.extras && roomSelect?.room?.extras.length > 0" class="mt-2 mb-4 room-extras" style="width: 100%">
    <usb-room-extras style="width: 100%"
                    [roomExtras]="roomSelect?.room?.extras"
                    [selectedRooms]="selectedRooms"
                    [currencyAgency]="currencyAgency"
                    [currencies]="currencies"
                    [buttonColorActive]="buttonColorActive"
                    [arrivalDate]="arrivalDate"
                    [extrasMap]="extrasMap"
                    (extrasChange)="onSelectionChangeExtras($event.action, $event.extra, $event.tabAddons)">
    </usb-room-extras>
  </div>


  <!-- CUARTOS SELECCIONADOS -->
<div class="selected-rooms-container" #containingDiv>
  <div class="selected-rooms-list" #selectedRoomsDiv>

    <p *ngIf="selectedRooms && selectedRooms.length > 0" class="room-options-title"
    style="margin-bottom: 12px;
           margin-top: 25px;
           margin-left: 8px;"
           >Habitaciones seleccionadas</p>

    <div *ngFor="let selectedRoom of selectedRooms; let i = index; trackBy: trackByRoomId" class="selected-room-item">

      <div class="selected-room-card" [class.height-additional]="getRoomExtras(selectedRoom)?.length > 0">

        <div class="room-info-wrapper">

          <div class="room-details" [class.has-extras]="getRoomExtras(selectedRoom)?.length > 0">
            <p class="room-title">
              {{ selectedRoom?.service?.boardName }} -
              <span class="room-rate" [class.refundable]="selectedRoom?.service?.rateClass === 'R'"
                                   [class.non-refundable]="selectedRoom?.service?.rateClass !== 'R'">
                {{ getNameRateClass(selectedRoom?.service?.rateClass) }}
              </span> -
              <span class="room-occupancy">
                {{ selectedRoom.room.qtyAdults }} Adultos, {{ selectedRoom.room.qtyChilds }} Niños {{selectedRoom.room.qtyChilds > 0 ? getChildrenAge(selectedRoom.room) : ''}}
              </span>
              - {{ currencyAgency.code }} {{ getFinalPrice(selectedRoom) | number: '1.2-2' }}
            </p>
          </div>

          <div *ngIf="getRoomExtras(selectedRoom)?.length > 0" class="room-extras-list">
            <div *ngFor="let extra of getRoomExtras(selectedRoom); let i = index; let last = last" class="extras-wrapper" [class.extras-wrapper-border]="!last">
              <img [src]="getExtraIcon(extra)" class="extras-icon"
                    [alt]="getExtraType(extra)">
              <p class="extras-text">{{ extra.title || extra.name }}</p>
            </div>
          </div>

        </div>

        <div class="btn-delete-room"
             (click)="offSelectionRooms(roomSelect, i, selectedRoom, false)"
             tooltip="Eliminar habitación"
             placement="bottom">
                    <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                      style="fill: #ff3f63; width: 25px;" xml:space="preserve">
                      <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                        c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                        c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                        c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                        c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                      <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C153.6,439.4,161.3,447,170.7,447z"/>
                      <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                        "/>
                      <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C324.3,439.4,331.9,447,341.3,447z"/>
                    </svg>
        </div>


      </div>
    </div>
  </div>
</div>

  <usb-accordion-info-product
    #accordionComponent
    [items]="accordionItemsData"
    [config]="accordionConfigData"
    [categoryId]="1"
    (itemToggle)="onAccordionToggle($event)">

    <ng-template #accordionContent let-item let-index="index">
      <ng-container [ngSwitch]="item.id">

        <!-- Descripción -->
        <div *ngSwitchCase="'description'">
          <p class="mb-0 usb-modal-text--body" [innerHTML]="item.data?.descriptionRate"></p>
        </div>

         <div *ngSwitchCase="'amenities'">
          <p class="mb-0 text-description-accordion"
          [innerHTML]="amenitiesData"
          *ngIf="amenitiesData; else noDesc">
          </p>
          <ng-template #noDesc>
            <p class="text-muted">No hay información disponible</p>
          </ng-template>
        </div>



        <!-- Políticas de Cancelación -->
        <!-- <div *ngSwitchCase="'policies'">
          <usb-cancellation-policies
            class="accordion-item-policies"
            #politicsSection
            [cancellationPolicies]="cancellationData"
            [currencies]="currencies"
            [currencyAgency]="currencyAgency"
            [categoryId]="1">
          </usb-cancellation-policies>
        </div> -->

      </ng-container>
    </ng-template>

  </usb-accordion-info-product>

</div>
